import { connect } from 'react-redux'
import { lifecycle, compose } from 'recompose'
import RegistrationFormWrapper from '../../components/registrationFormWrapper/registrationFormWrapperComponent'
import { State } from '../../redux/reducers/'
import { reset } from 'redux-form'
import { actionCreators } from '../../redux/reducers/ui/uiReducer'
import { actionCreators as loginActions } from '../../redux/reducers/login/loginReducer'
import { actionCreators as asyncActionCreators } from '../../redux/sagas/registration/registrationSaga'

// Global State
export function mapStateToProps (state: State, props): Values {
  return {
    formPage: state.ui.registrationPage
  }
}
// In Object form, each funciton is automatically wrapped in a dispatch
// export const propsMapping: Callbacks = {
//   changeRegistrationPage: actionCreators.changeRegistrationPage,
//   onSubmit: asyncActionCreators.register,
//   toggleRegistration: actionCreators.toggleRegistrationModal,
//   toggleLogin: loginActions.showLogin
// }

// If you want to use the function mapping
export const propsMapping = (dispatch, ownProps) => {
  return {
    changeRegistrationPage: action =>
      dispatch(actionCreators.changeRegistrationPage(action)),
    onSubmit: action => dispatch(asyncActionCreators.register(action)),
    toggleRegistration: action =>
      dispatch(actionCreators.toggleRegistrationModal(action)),
    toggleLogin: action => dispatch(loginActions.showLogin(action)),
    reset: action => dispatch(reset('registration'))
  }
}

// export default connect(mapStateToProps, propsMapping)(RegistrationFormWrapper)

export default compose(
  connect(mapStateToProps, propsMapping),
  lifecycle({
    componentWillUnmount: function () {
      if (this.props.changeRegistrationPage) {
        this.props.changeRegistrationPage(1)
      }
      if (this.props.reset) {
        this.props.reset()
      }
    }
  })
)(RegistrationFormWrapper)



// WEBPACK FOOTER //
// ./src/containers/registrationFormWrapper/registrationFormWrapperContainer.js